import {INFRASTRUCTURE_HEADERS, LEAKS_HEADERS, TECHNOLOGIES_HEADERS} from '@/constants/configuration';
import getters from './getters';
import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';

const state = {
  downloadReportDisabled: false,
  successOperationMessage: '',
  topLevelDomainListOptions: {
    sort: {
      configData: 'asc',
    },
    limit: 20,
    page: 1,
    search: '',
    filter: '',
    onlyValidated: false,
    has360: false,
  },
  infrastructureListOptions: {
    sort: {
      [INFRASTRUCTURE_HEADERS['infrastructure.tab.default.header']]: 'desc',
    },
    limit: 20,
    page: 1,
    search: '',
    filter: '',
    hasPorts: true,
    hasIssue: false,
    hideUnresolved: true,
    onlyNew: false,
    onlyManual: false,
    onlyRepetitive: false,
  },
  leaksListOptions: {
    sort: {
      [LEAKS_HEADERS['leaksDataTable.source']]: 'asc',
    },
    limit: 20,
    page: 1,
    search: '',
    type: '',
    source: '',
    review: '',
    important: false,
  },
  technologiesListOptions: {
    sort: {
      [TECHNOLOGIES_HEADERS['technologyTabTable.technology']]: 'desc',
    },
    limit: 20,
    page: 1,
    search: '',
    filter: '',
    hasExploit: false,
  },
  topLevelDomains: [],
  topLevelDomainsAssets: [],
  topLevelDomainsOptions: [],
  infrastructureItems: [],
  portOptions: [],
  wafOptions: [],
  servicesOptions: [],
  locationOptions: {},
  coordinatesOptions: {},
  infrastructureTagsSuggestions: [],
  topLevelDomainTagsSuggestions: [],
  leaksItems: [],
  tldsWithNoLeaksScan: [],
  tldsWithLeaksScan: [],
  leaksSourceOptions: [],
  leaksTypeOptions: [],
  employeesListOptions: {
    sort: {
      default: 'asc',
    },
    limit: 20,
    page: 1,
    search: '',
    filter: '',
    hasCredentials: false,
    authorized: false,
  },
  employeesItems: [],
  tldsWithNoEmployeesScan: [],
  tldsWithEmployeesScan: [],
  technologiesItems: [],
  passwordSprayStatsUpdated: false,
  cloudInstancesListOptions: {
    sort: {
      default: 'asc',
    },
    limit: 20,
    page: 1,
    search: '',
    filter: '',
    exposed: false,
    showSuppress: false,
  },
  cloudInstancesItems: [],
  cloudInstancesFullItems: [],
  cloudBucketsListOptions: {
    sort: {
      default: 'asc',
    },
    limit: 20,
    page: 1,
    search: '',
    filter: '',
    exposed: false,
    showSuppress: false,
  },
  cloudBucketsItems: [],
  cloudBucketsFullItems: [],
  loadingPasswordSpray: false,
  notValidatedDomains: [],
  domainsWithoutLicense: [],
  infostealersListOptions: {
    sort: {},
    limit: 20,
    page: 1,
    search: '',
    filter: '',
    filters: {},
    hasExploit: false,
  },
  infostealersItems: [],
  topLevelDomainsLoading: false,
  infrastructureLoading: false,
  employeesLoading: false,
  technologiesLoading: false,
  leaksLoading: false,
  cloudInstancesLoading: false,
  cloudBucketsLoading: false,
  cloudServicesLoading: false,
  cloudAccountsLoading: false,
  infrastructureRefId: '',
  infrastructureProgress: 0,
  employeesRefId: '',
  employeesProgress: 0,
  technologiesRefId: '',
  technologiesProgress: 0,
  cloudInstancesRefId: '',
  cloudInstancesProgress: 0,
  cloudBucketsRefId: '',
  cloudBucketsProgress: 0,
  cloudServicesRefId: '',
  cloudServicesProgress: 0,
  topLevelDomainsRefId: '',
  topLevelDomainsProgress: 0,
  leaksRefId: '',
  leaksProgress: 0,
  leaksRunningInterval: false,
  infrastructureRunningInterval: false,
  tldRunningInterval: false,
  cloudInstancesRunningInterval: false,
  technologiesRunningInterval: false,
  employeesRunningInterval: false,
  cloudBucketsRunningInterval: false,
  cloudServicesRunningInterval: false,
  infostealersLoading: false,
  infostealersFilters: {},
  infostealersPaginationState: {
    page: 1,
    itemsPerPage: 20,
    total: 0,
    hasNext: false,
    hasPrevious: false,
    totalPages: 1,
  },
  infostealersRefId: '',
  infostealersProgress: 0,
  infostealersRunningInterval: false,
  infostealersProgressData: { running_jobs: [], total_running: 0 },
  infostealersPollingInterval: null,
  lastInfostealersProgressCall: null,
  retryCounter: {
    topLevelDomain: 0,
    infrastructure: 0,
    cloudInstances: 0,
    cloudBuckets: 0,
    cloudServices: 0,
    employees: 0,
    technologies: 0,
    leaks: 0,
    issues: 0,
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
